<template>
  <v-container style="overflow: auto; min-height: 700px; max-height: 700px;">

    <!-- -------------แผนที่แสดงบ้านของผู้รับบริการและแหล่งประโยชน์ในชุมชน------------- -->

    <v-form ref="form1">
      <v-row class="pt-10" justify="center">
        <v-col cols="auto">
          <span class="text-333333 w-700 font-18">แผนที่แสดงบ้านของผู้รับบริการและแหล่งประโยชน์ในชุมชน</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" lg="4" md="4" sm="4">
          <span class="pr-3 font-16 w-600 text-333333">ละติจูด</span>
          <span class="pr-3 font-16 w-500 text-333333">{{map_detail.lat || '-'}}</span>
        </v-col>
        <v-col cols="12" lg="4" md="4" sm="4">
          <span class="pr-3 font-16 w-600 text-333333">ลองติจูด</span>
          <span class="pr-3 font-16 w-500 text-333333">{{map_detail.lng || '-'}}</span>
        </v-col>
      </v-row>
      <v-row ref="printcontent" id="capture">
        <v-col cols="12" class="pt-0 pb-4">
          <StadiaMap ref="locateUser" :items="map_detail" :draggable="false" />
          <!-- <GmapMap
            :center="{ lat: latitude, lng: longitude }"
            :zoom="15"
            class="map"
            :options="{
              zoomControl: false,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
              disableDefaultUi: false,
            }"
          >
            <GmapMarker
              :draggable="false"
              :position="{
                lat: lat,
                lng: lng,
              }"
            />
          </GmapMap> -->
        </v-col>
      </v-row>
      <v-row class="pt-0 pb-10 px-3">
        <span class="font-16 w-600 text-333333 pr-3">อยู่ในพื้นที่รับผิดชอบของหน่วยบริการหลัก คือ</span>
        <span class="pr-3 font-16 w-500 text-333333">{{map_detail.area_of_responsibility || '-'}}</span>
      </v-row>
      
      <!-- <v-row class="pt-0">
        <v-col cols="12" lg="12" md="12" sm="12" class="pt-0 pr-0" align-self="center" >
          <span class="font-16 w-600 text-333333" style="text-decoration: underline">สัญลักษณ์</span>
        </v-col>
        <v-col cols="12" lg="12" md="12" sm="12" class="px-6">
          <v-row style="border: 1px solid #000000;">
            <v-col v-for="item in symbol_list" :key="item.id" cols="12" mg="6" sm="6" lg="4" xl="4" class="pa-0">
              <v-card outlined tile style="border: 1px solid #000000;">
                <v-card-text>
                  <v-row class="pl-3 pr-8" style="height: 80px;">
                    <v-col cols="8" xl="6" lg="6" md="6" sm="6" align-self="start">
                      <span class="font-16 text-333333">{{ item.symbol }}</span>
                    </v-col>
                    <v-col cols="4" xl="6" lg="6" md="6" sm="6" class="pr-0" style="text-align: -webkit-right;" align-self="center">
                      <v-img :src="item.img" contain max-width="45"/>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row> -->

      <!-- -------------------------ประวัติครอบครัว-------------------------- -->

      <v-row class="pt-10 pb-6" justify="center">
        <v-col cols="12" class="pr-0 pt-2" align="center">
          <span class="w-700 font-18 text-333333">การประเมินสภาพครอบครัว/ประวัติครอบครัว จำนวนสมาชิกในบ้าน {{family_detail.family_member}} คน</span>
        </v-col>
      </v-row>
      <div v-if="family_detail.family_list.length !== 0" class="px-3 pt-3 pb-10" style="min-height: 25vh; max-height: 555px;overflow-x: hidden;overflow-y: auto;">
        <v-row class="pt-0 pb-5 mx-0" v-for="(item, index) in family_detail.family_list" :key="index">
          <v-col cols="12" style="border: 1px solid #00A99D; border-radius: 10px; padding: 15px 0px;" :id="family_detail.family_list.length - index == 1 ? 'content' : index">
            <v-row class="px-5 mt-0 pb-0">
              <v-col cols="12" class="pt-0">
                <span class="text-333333 w-600 font-16">สมาชิกคนที่ : {{ index+ 1 }}</span>
              </v-col>
            </v-row>
            <v-row class="px-5">
              <v-col cols="12" sm="8" md="4" lg="4">
                <span class="font-16 w-600 text-333333 pr-3 pt-2">ชื่อ </span>
                <span class="font-16 w-500 text-333333 pr-3 pt-2">{{family_detail.family_list[index].name || '-'}}</span>
              </v-col>
              <v-col cols="12" sm="4" md="2" lg="2">
                <span class="font-16 w-600 text-333333 pr-3 pt-2">อายุ </span>
                <span class="font-16 w-500 text-333333 pr-3 pt-2">{{family_detail.family_list[index].age || '-'}}</span>
                <span class="font-16 w-600 text-333333 pr-3 pt-2">ปี</span> 
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="3">
                <span class="font-16 w-600 text-333333 pr-3 pt-2">อาชีพ </span>   
                <span class="font-16 w-500 text-333333 pr-3 pt-2">{{family_detail.family_list[index].occupation || '-'}}</span> 
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="3">
                <span class="font-16 w-600 text-333333 pr-3 pt-2">สิทธิการรักษา </span>
                <span class="font-16 w-500 text-333333 pr-3 pt-2">{{family_detail.family_list[index].right_of_treatment || '-'}}</span>
              </v-col>
              <v-col cols="12">
                <span class="font-16 w-600 text-333333 pr-3 pt-2">ลักษณะที่ประเมิน/ตรวจพบ </span>
                <span class="font-16 w-500 text-333333 pr-3 pt-2">{{family_detail.family_list[index].detected_characteristics || '-'}}</span>
              </v-col> 
            </v-row>
          </v-col>
        </v-row>
      </div>

      <v-row v-else class="py-16 mx-1" style="border: 1px solid #00A99D; border-radius: 10px;">
        <v-col cols="12" align="center">
          <span class="font-16 w-500">ไม่พบข้อมูลการประเมินสภาพครอบครัว/ประวัติครอบครัวจำนวนสมาชิกในบ้าน</span>
        </v-col>
      </v-row>

      <!-- --------------------ผังเครือญาติ----------------------- -->
      <v-row class="pt-10" justify="center">
        <v-col cols="auto">
          <span class="w-700 font-18 text-333333">ผังเครือญาติ</span>
        </v-col>
      </v-row>
      <v-row class="pb-10 pt-2 px-4 d-flex d-flex-row">
        <v-col cols="12" sm="4" md="3" lg="3" xl="2" class="py-0">
          <img max-width="100%" max-height="500px" src="@/assets/image/Group.png" />
        </v-col>
        <v-col cols="12" sm="8" md="9" lg="9" xl="10" align="center" class="py-0">
          <v-card outlined style="border: 2px solid #00A99D;" min-height="650px">
            <img
              v-if="family_detail.family_image"
              :src="family_detail.family_image"
              height="650px"
              width="100%"
            />
          </v-card>
        </v-col>
      </v-row>

      <!-- ----------------Family Problem & Other Problem---------------- -->
      <v-row class="pt-10" justify="center">
        <v-col cols="auto">
          <span class="w-700 font-18 text-333333">Family Problem & Other Problem</span>
        </v-col>
      </v-row>
      <v-row class="pb-0 pt-2 pl-6">
        <v-col cols="12" class="py-0">
          <span class="w-700 font-16 text-333333 pr-3">ปัญหาในครอบครัวและมุมมองต่อผู้รับบริการ</span>
        </v-col>
      </v-row>
      <v-row class="pb-0 pt-2 pl-16 pr-3">
          <span class="w-500 font-16 text-333333 pr-3">{{family_detail.family_problem.family_problems_and_perspectives_on_servants.title || '-'}}</span>
          <span class="w-500 font-16 text-333333 pr-3" v-if="family_detail.family_problem.family_problems_and_perspectives_on_servants.status == '2'">ระบุ {{family_detail.family_problem.family_problems_and_perspectives_on_servants.detail}}</span>
      </v-row>
      <v-row class="pb-0 pt-2 pl-6">
        <v-col cols="12" class="py-0">
          <span class="w-700 font-16 text-333333">การรับรู้ของผู้รับบริการต่อปัญหาในครอบครัว</span>
        </v-col>
      </v-row>
      <v-row class="pb-0 pt-2 pl-16 pr-3">
        <span class="pr-3 font-16 text-333333">การรับรู้ มุมมอง ต่อปัญหาและความช่วยเหลือ</span>
        <span class="w-500 font-16 text-333333 pr-3">{{family_detail.family_problem.servant_perception_of_Family_problems.detail || '-'}}</span>
      </v-row>
      <v-row class="pb-0 pt-2 pl-6">
        <v-col cols="12" class="py-0">
          <span class="w-700 font-16 text-333333">ความต้องการช่วยเหลือของผู้ป่วย</span>
        </v-col>
      </v-row>
      <v-row class="pb-0 pt-2 pl-16">
        <v-col cols="12" class="px-0 pt-0" 
          v-if="family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.status == '0' &&
          family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.status == '0' &&
          family_detail.family_problem.patient_need_for_help.supporting_the_economy.status == '0' &&
          family_detail.family_problem.patient_need_for_help.other_detail.status == '0'" >
          <span class="w-500 font-16 text-333333 pr-3">-</span>
        </v-col>
        <v-col cols="12" class="px-0 pt-0" v-if="family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.status == '1'" >
          <span class="w-500 font-16 text-333333 pr-3">{{family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.title}}</span>
          <span class="w-500 font-16 text-333333 pr-3">ระบุ {{family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.detail}}</span>
        </v-col>
        <v-col cols="12" class="px-0 pt-0" v-if="family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.status == '1'" >
          <span class="w-500 font-16 text-333333 pr-3">{{family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.title}}</span>
          <span class="w-500 font-16 text-333333 pr-3">ระบุ {{family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.detail}}</span>
        </v-col>
        <v-col cols="12" class="px-0 pt-0" v-if="family_detail.family_problem.patient_need_for_help.supporting_the_economy.status == '1'" >
          <span class="w-500 font-16 text-333333 pr-3">{{family_detail.family_problem.patient_need_for_help.supporting_the_economy.title}}</span>
          <span class="w-500 font-16 text-333333 pr-3">ระบุ {{family_detail.family_problem.patient_need_for_help.supporting_the_economy.detail}}</span>
        </v-col>
        <v-col cols="12" class="px-0 pt-0" v-if="family_detail.family_problem.patient_need_for_help.other_detail.status == '1'" >
          <span class="w-500 font-16 text-333333 pr-3">{{family_detail.family_problem.patient_need_for_help.other_detail.title}}</span>
          <span class="w-500 font-16 text-333333 pr-3">ระบุ {{family_detail.family_problem.patient_need_for_help.other_detail.detail}}</span>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import html2canvas from 'html2canvas'
import StadiaMap from "@/components/stadiamap/StadiaMap.vue";

export default {
  components: { StadiaMap },
  data() {
    return {
      dialog: false,
      nav: null,
      url: null,
      image: null,
      data: {
        lat: 0,
        lng: 0,
      },
      location_address: '',
      latitude: 0,
      longitude: 0,
      lat: 0,
      lng: 0,
      isWrite: false,
      symbol_list: [
        { id: 1, symbol: 'บ้าน', img: require('@/assets/icon/visit/home.svg') },
        { id: 2, symbol: 'แม่น้ำ', img: require('@/assets/icon/visit/river.svg') },
        { id: 3, symbol: 'สถานประกอบการ', img: require('@/assets/icon/visit/factory.svg') },
        { id: 4, symbol: 'วัด', img: require('@/assets/icon/visit/wat-phra-kaew.svg') },
        { id: 5, symbol: 'สระน้ำ', img: require('@/assets/icon/visit/swimming-pool.svg') },
        { id: 6, symbol: 'โรงเรียน', img: require('@/assets/icon/visit/school.svg') },
        { id: 7, symbol: 'สถานีอนามัยศูนย์บริการสาธารณสุข', img: require('@/assets/icon/visit/medical-symbol.svg') },
        { id: 8, symbol: 'มัสยิด', img: require('@/assets/icon/visit/mosque.svg') },
        { id: 9, symbol: 'คลินิก', img: require('@/assets/icon/visit/pharmacy.svg') },
        { id: 10, symbol: 'โรงพยาบาล', img: require('@/assets/icon/visit/hospital-building.svg') },
        { id: 11, symbol: 'ศูนย์สุขภาพชุมชน', img: require('@/assets/icon/visit/clinic.svg') },
        { id: 12, symbol: '', img: '' }
      ],
      map_detail: {
        lat: '',
        lng: '',
        map_image: '',
        file_id_map_location: '',
        area_of_responsibility: ''
      },
      family_detail: {
        family_member: 1,
        family_list: [
          {
            name: "",
            age: "",
            occupation: "",
            right_of_treatment: "",
            detected_characteristics: ""
          }
        ],
        family_image: '',
        family_problem: {
          family_problems_and_perspectives_on_servants: { // ปัญหาในครอบครัวและมุมมองต่อผู้รับบริการ
            status: '',
            detail: "",
            title: ""
          },
          servant_perception_of_Family_problems: { // การรับรู้ของผู้รับบริการต่อปัญหาในครอบครัว
            detail: "",
          },
          patient_need_for_help: { //ความต้องการช่วยเหลือของผู้ป่วย
            knowledge_of_disease_counseling: { //ความรู้คำปรึกษา
              status: '0',
              detail: "",
              title: ""
            },
            support_for_specified_reclamation_tools: { //สนับสนุน เครื่องมือ ฟื้นฟูสมรรถภาพ
              status: '0',
              detail: "",
              title: "" 
            },
            supporting_the_economy: { //สนับสนุนด้านเศรษฐกิจ
              status: '0',
              detail: "",
              title: "" 
            },
            other_detail: { //อื่นๆ
              status: '0',
              detail: "",
              title: "" 
            }
          }
        },
        file_id_family_image: '',
      },
      rules_checkbox: [(v) => !!v || "กรุณาเลือกข้อมูล"],
      rules_detail: [(v) => !!v || "กรุณาระบุข้อมูล"],
      rules_member: [
        (v) => !!v || "กรุณาระบุข้อมูล",
        (v) => v>0 || 'กรุณาระบุข้อมูลที่มากกว่า 0'
      ],
      map_image_HTML: "",
      family_image_HTML: "",
    }
  },
  computed: {
    display_vuetify() {
      return this.$vuetify.breakpoint.name
    },
  },
  mounted() {
    this.checkGPS();
  },
  methods: {
    async openPage(map_detail, family_detail) {
      // console.log('map_detail', map_detail);
      // console.log('family_detail', family_detail);
      
      this.map_detail = {
        lat: 'lat' in map_detail && map_detail.lat !== '' && map_detail.lat !== null && map_detail.lat !== undefined ? parseFloat(map_detail.lat) : 0,
        lng: 'lng' in map_detail && map_detail.lng !== '' && map_detail.lng !== null && map_detail.lng !== undefined ? parseFloat(map_detail.lng) : 0,
        map_image: 'map_image' in map_detail && map_detail.map_image !== '' && map_detail.map_image !== null && map_detail.map_image !== undefined ? map_detail.map_image : '',
        file_id_map_location: 'file_id_map_location' in map_detail && map_detail.file_id_map_location !== '' && map_detail.file_id_map_location !== null && map_detail.file_id_map_location !== undefined ? map_detail.file_id_map_location : '',
        area_of_responsibility: 'area_of_responsibility' && map_detail.area_of_responsibility !== null && map_detail.area_of_responsibility !== undefined ? map_detail.area_of_responsibility : '',
      }

      this.latitude = 'lat' in map_detail && map_detail.lat !== '' && map_detail.lat !== null && map_detail.lat !== undefined ? parseFloat(map_detail.lat) : 0
      this.longitude = 'lng' in map_detail && map_detail.lng !== '' && map_detail.lng !== null && map_detail.lng !== undefined ? parseFloat(map_detail.lng) : 0,
      this.lat = 'lat' in map_detail && map_detail.lat !== '' && map_detail.lat !== null && map_detail.lat !== undefined ? parseFloat(map_detail.lat) : 0
      this.lng = 'lng' in map_detail && map_detail.lng !== '' && map_detail.lng !== null && map_detail.lng !== undefined ? parseFloat(map_detail.lng) : 0,

      this.family_detail = {
        family_member: 'family_member' in family_detail && family_detail.family_member !== '' && family_detail.family_member !== null && family_detail.family_member !== undefined ? family_detail.family_member : 0,
        family_list: 'family_list' in family_detail && family_detail.family_list.length !== 0 && family_detail.family_list.length !== null && family_detail.family_list.length !== undefined ? family_detail.family_list : [],
        family_image: 'family_image' in family_detail && family_detail.family_image !== '' && family_detail.family_image !== null && family_detail.family_image !== undefined ? family_detail.family_image : '',
        family_problem: {
          family_problems_and_perspectives_on_servants: { // ปัญหาในครอบครัวและมุมมองต่อผู้รับบริการ
            status: 'family_problem' in family_detail && 'family_problems_and_perspectives_on_servants' in family_detail.family_problem && 'status' in  family_detail.family_problem.family_problems_and_perspectives_on_servants && family_detail.family_problem.family_problems_and_perspectives_on_servants.status !== '' && family_detail.family_problem.family_problems_and_perspectives_on_servants.status !== null && family_detail.family_problem.family_problems_and_perspectives_on_servants.status !== undefined ? family_detail.family_problem.family_problems_and_perspectives_on_servants.status : '',
            detail: 'family_problem' in family_detail && 'family_problems_and_perspectives_on_servants' in family_detail.family_problem && 'detail' in  family_detail.family_problem.family_problems_and_perspectives_on_servants && family_detail.family_problem.family_problems_and_perspectives_on_servants.detail !== '' && family_detail.family_problem.family_problems_and_perspectives_on_servants.detail !== null && family_detail.family_problem.family_problems_and_perspectives_on_servants.detail !== undefined ? family_detail.family_problem.family_problems_and_perspectives_on_servants.detail : '',
            title: 'family_problem' in family_detail && 'family_problems_and_perspectives_on_servants' in family_detail.family_problem && 'title' in  family_detail.family_problem.family_problems_and_perspectives_on_servants && family_detail.family_problem.family_problems_and_perspectives_on_servants.title !== '' && family_detail.family_problem.family_problems_and_perspectives_on_servants.title !== null && family_detail.family_problem.family_problems_and_perspectives_on_servants.title !== undefined ? family_detail.family_problem.family_problems_and_perspectives_on_servants.title : '',
          },
          servant_perception_of_Family_problems: { // การรับรู้ของผู้รับบริการต่อปัญหาในครอบครัว
            detail: 'family_problem' in family_detail && 'servant_perception_of_Family_problems' in family_detail.family_problem && 'detail' in family_detail.family_problem.servant_perception_of_Family_problems && family_detail.family_problem.servant_perception_of_Family_problems.detail !== '' && family_detail.family_problem.servant_perception_of_Family_problems.detail !== null && family_detail.family_problem.servant_perception_of_Family_problems.detail !== undefined ? family_detail.family_problem.servant_perception_of_Family_problems.detail : '',
          },
          patient_need_for_help: { //ความต้องการช่วยเหลือของผู้ป่วย
            knowledge_of_disease_counseling: { //ความรู้คำปรึกษา
              status: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'knowledge_of_disease_counseling' in family_detail.family_problem.patient_need_for_help && 'status' in family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling && family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.status !== '' && family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.status !== null && family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.status !== undefined ? family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.status : '',
              detail: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'knowledge_of_disease_counseling' in family_detail.family_problem.patient_need_for_help && 'detail' in family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling && family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.detail !== '' && family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.detail !== null && family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.detail !== undefined ? family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.detail : '',
              title: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'knowledge_of_disease_counseling' in family_detail.family_problem.patient_need_for_help && 'title' in family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling && family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.title !== '' && family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.title !== null && family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.title !== undefined ? family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.title : '',
            },
            support_for_specified_reclamation_tools: { //สนับสนุน เครื่องมือ ฟื้นฟูสมรรถภาพ
              status: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'support_for_specified_reclamation_tools' in family_detail.family_problem.patient_need_for_help && 'status' in family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools && family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.status !== '' && family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.status !== null && family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.status !== undefined ? family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.status : '',
              detail: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'support_for_specified_reclamation_tools' in family_detail.family_problem.patient_need_for_help && 'detail' in family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools && family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.detail !== '' && family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.detail !== null && family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.detail !== undefined ? family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.detail : '',
              title: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'support_for_specified_reclamation_tools' in family_detail.family_problem.patient_need_for_help && 'title' in family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools && family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.title !== '' && family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.title !== null && family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.title !== undefined ? family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.title : '',
            },
            supporting_the_economy: { //สนับสนุนด้านเศรษฐกิจ
              status: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'supporting_the_economy' in family_detail.family_problem.patient_need_for_help && 'status' in family_detail.family_problem.patient_need_for_help.supporting_the_economy && family_detail.family_problem.patient_need_for_help.supporting_the_economy.status !== '' && family_detail.family_problem.patient_need_for_help.supporting_the_economy.status !== null && family_detail.family_problem.patient_need_for_help.supporting_the_economy.status !== undefined ? family_detail.family_problem.patient_need_for_help.supporting_the_economy.status : '',
              detail: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'supporting_the_economy' in family_detail.family_problem.patient_need_for_help && 'detail' in family_detail.family_problem.patient_need_for_help.supporting_the_economy && family_detail.family_problem.patient_need_for_help.supporting_the_economy.detail !== '' && family_detail.family_problem.patient_need_for_help.supporting_the_economy.detail !== null && family_detail.family_problem.patient_need_for_help.supporting_the_economy.detail !== undefined ? family_detail.family_problem.patient_need_for_help.supporting_the_economy.detail : '',
              title: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'supporting_the_economy' in family_detail.family_problem.patient_need_for_help && 'title' in family_detail.family_problem.patient_need_for_help.supporting_the_economy && family_detail.family_problem.patient_need_for_help.supporting_the_economy.title !== '' && family_detail.family_problem.patient_need_for_help.supporting_the_economy.title !== null && family_detail.family_problem.patient_need_for_help.supporting_the_economy.title !== undefined ? family_detail.family_problem.patient_need_for_help.supporting_the_economy.title : '',
            },
            other_detail: { //อื่นๆ
              status: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'other_detail' in family_detail.family_problem.patient_need_for_help && 'status' in family_detail.family_problem.patient_need_for_help.other_detail && family_detail.family_problem.patient_need_for_help.other_detail.status !== '' && family_detail.family_problem.patient_need_for_help.other_detail.status !== null && family_detail.family_problem.patient_need_for_help.other_detail.status !== undefined ? family_detail.family_problem.patient_need_for_help.other_detail.status : '',
              detail: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'other_detail' in family_detail.family_problem.patient_need_for_help && 'detail' in family_detail.family_problem.patient_need_for_help.other_detail && family_detail.family_problem.patient_need_for_help.other_detail.detail !== '' && family_detail.family_problem.patient_need_for_help.other_detail.detail !== null && family_detail.family_problem.patient_need_for_help.other_detail.detail !== undefined ? family_detail.family_problem.patient_need_for_help.other_detail.detail : '',
              title: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'other_detail' in family_detail.family_problem.patient_need_for_help && 'title' in family_detail.family_problem.patient_need_for_help.other_detail && family_detail.family_problem.patient_need_for_help.other_detail.title !== '' && family_detail.family_problem.patient_need_for_help.other_detail.title !== null && family_detail.family_problem.patient_need_for_help.other_detail.title !== undefined ? family_detail.family_problem.patient_need_for_help.other_detail.title : '',
            }
          }
        },
        file_id_family_image: 'file_id_family_image' in family_detail && family_detail.file_id_family_image !== '' && family_detail.file_id_family_image !== null && family_detail.file_id_family_image !== undefined ? family_detail.file_id_family_image : ''
      }

      if ('file_id_family_image' in family_detail && family_detail.file_id_family_image !== '' && family_detail.file_id_family_image !== null && family_detail.file_id_family_image !== undefined) {
        await this.get_img_onebox(family_detail.file_id_family_image, 'family')

        if (this.family_image_HTML !== '') {
          this.family_detail.family_image = this.family_image_HTML
        }
      } else {
        if ('family_image' in family_detail && family_detail.family_image !== '' && family_detail.family_image !== null && family_detail.family_image !== undefined) {
          this.family_detail.family_image = family_detail.family_image
        } else {
          this.family_detail.family_image = ''
        }
      }

      if ('file_id_map_location' in map_detail && map_detail.file_id_map_location !== '' && map_detail.file_id_map_location !== null && map_detail.file_id_map_location !== undefined) {
        await this.get_img_onebox(map_detail.file_id_map_location, 'map')

        if (this.map_image_HTML !== '') {
          this.map_detail.map_image = this.map_image_HTML
        }
      } else {
        if ('map_image' in map_detail && map_detail.map_image !== '' && map_detail.map_image !== null && map_detail.map_image !== undefined) {
          this.map_detail.map_image = map_detail.map_image
        } else {
          this.map_detail.map_image = ''
        }
      }

    },
    async get_img_onebox(item, text) {
      try {
        const params = new URLSearchParams();
        params.append("file_id", item);

        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/download_home_visit_one_box?${params}`).then((res) => {
          console.log('onebox', res);
          if (res.data.result == 'success' && res.data.code == 200) {
            if (res.data.data !== '' && res.data.data !== null && res.data.data !== undefined) {
              if (text == 'family') {
                this.family_image_HTML = 'data:image/png;base64,' + res.data.data
              } else if (text == 'map') {
                this.map_image_HTML = 'data:image/png;base64,' + res.data.data
              }
            } else {
              if (text == 'family') {
                this.family_image_HTML = ''
              } else if (text == 'map') {
                this.map_image_HTML = ''
              }
            }
          }
        })
      } catch(err) {
        console.log(err);
      }
    },
    async get_img() {
      var target = await this.$refs.printcontent;
      var img = ''
      await html2canvas(target, {
          useCORS: true,
          imageTimeout: 500,
      })
      .then(function (canvas) {
        img = canvas.toDataURL("image/png");
      })
      .catch(function (err) {
        console.log(err);
      });
      if(img !== "data:,") {
        this.map_detail.map_image = img
      }
      
    },
    getGPS() {
      this.latitude = parseFloat(this.map_detail.lat || 0);
      this.longitude = parseFloat(this.map_detail.lng || 0);
      this.lat = parseFloat(this.map_detail.lat || 0);
      this.lng = parseFloat(this.map_detail.lng || 0);
    },
    checkGPS() {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { coords: { latitude: lat, longitude: lng } = {} } = position;
          this.latitude = lat;
          this.longitude = lng;
          this.map_detail.lat = lat;
          this.map_detail.lng = lng;
          this.lat = lat;
          this.lng = lng;
        },
        (error) => {
          console.log(error);
        }
      );
    },
    changeLocation(e) {
      this.map_detail.lat = e.latLng.lat();
      this.map_detail.lng = e.latLng.lng();
      this.lat = e.latLng.lat();
      this.lng = e.latLng.lng();
    },
     async getLocation(address) {
      try {
        const params = new URLSearchParams();
        params.append("address", address);

        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/pharma/get-location?${params}`).then((res) => {
          if (res.data.result == "success" && res.data.code == 200) {
            var data = res.data.data
            this.latitude = data.lat;
            this.longitude = data.lng;
            this.map_detail.lat = data.lat;
            this.map_detail.lng = data.lng;
            this.lat = data.lat;
            this.lng = data.lng;
          }
        });
      } catch (error) {
        console.error();
      }
    },
  },
}
</script>

<style scoped>
.text_name {
  text-align: end;
  padding-bottom: 0px;
  padding-left: 10px;
  justify-self: center;
  align-self: center;
}
.text_Body {
  align-self: center;
  padding-top: 0px;
  padding-bottom: 0px;
  justify-content: center;
}
.text_body {
  align-self: center;
  padding-bottom: 0px;
  justify-content: center;
}
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
::v-deep .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    border-color: #00A99D !important;
}

::v-deep .v-input--selection-controls__input + .v-label {
  font-size: 16px !important;
  color: #333333 !important;
}

::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep .theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: #333333;
}

::v-deep .v-input--is-disabled > .v-input__control > .v-input__slot {
  background: #e8e9e9 !important;
}

::v-deep .v-toolbar__content {
  justify-content: center;
}

.text-red {
  color: red;
}

.container {
  max-width: 100%;
  max-height: 700px;
}

.v-dialog > .v-card > .v-card__text {
  padding: 0px;
}

.map {
  border-radius: 15px !important;
  height: 30vh;
  width: 100%;
}
#map {
  border-radius: 15px !important;
  height: 30vh;
  width: 100%;
}

::v-deep .v-dialog {
  background-color: white !important;
}

::v-deep
  .v-text-field.v-text-field--solo.v-input--dense
  .v-input__append-outer {
  margin-top: 0px !important;
}

::v-deep .theme--light.v-select .v-select__selection--disabled {
  color: #333333 !important;
}

.gmap-auto {
  width: 100%;
  line-height: 35px;
  border: 1px solid #e8e9e9;
  border-radius: 5px;
  font-size: 14px;
}

.gmap-auto:focus {
  outline: none !important;
}

::v-deep .v-select__selections {
  line-height: 1.8rem;
}

::v-deep .v-text-field.v-text-field--solo .v-input__control input {
  line-height: 1.8rem;
}

::v-deep .v-input input {
  line-height: 1.8rem;
}
</style>